// Vacation requests are date ranges of whole weeks (7–28 days) that may start
// on any day. Mirrors server/utils/vacationRequests.js.
import { format, addDays, parseISO, differenceInCalendarDays } from 'date-fns';

export const MAX_VACATION_DAYS = 28;
export const VACATION_LENGTHS = [
  { days: 7, label: '1 week' },
  { days: 14, label: '2 weeks' },
  { days: 21, label: '3 weeks' },
  { days: 28, label: '4 weeks' },
];

export function addDaysStr(dateStr, n) {
  return format(addDays(parseISO(dateStr), n), 'yyyy-MM-dd');
}

export function rangeEndStr(start, lengthDays) {
  return addDaysStr(start, lengthDays - 1);
}

export function rangeDays(start, end) {
  return differenceInCalendarDays(parseISO(end), parseISO(start)) + 1;
}

// "Wed 11 Nov – Tue 17 Nov 2026 (7 days)"
export function formatVacationRange(start, end) {
  if (!start || !end) return '';
  const s = parseISO(start);
  const e = parseISO(end);
  const sameYear = s.getFullYear() === e.getFullYear();
  const n = rangeDays(start, end);
  return `${format(s, sameYear ? 'EEE d MMM' : 'EEE d MMM yyyy')} – ${format(e, 'EEE d MMM yyyy')} (${n} day${n !== 1 ? 's' : ''})`;
}

// Do two ranges share at least one day?
export function rangesOverlap(a, b) {
  return a.start_date <= b.end_date && a.end_date >= b.start_date;
}

// Days of a range inside the given calendar year
export function daysInYear(start, end, year) {
  const s = start > `${year}-01-01` ? start : `${year}-01-01`;
  const e = end < `${year}-12-31` ? end : `${year}-12-31`;
  return s <= e ? rangeDays(s, e) : 0;
}

// Form entries are { start_date, length_days }; legacy entries { week_start } are 7-day weeks
export function normaliseFormEntry(w) {
  if (!w) return null;
  if (w.start_date) return { start_date: w.start_date, length_days: Number(w.length_days) || 7 };
  if (w.week_start) return { start_date: w.week_start, length_days: 7 };
  return null;
}

export function formEntryKey(e) {
  return `${e.start_date}|${rangeEndStr(e.start_date, e.length_days)}`;
}
